import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"sidePanel":"sidepanel_sidePanel__sefSL","left":"sidepanel_left__++Pn7","right":"sidepanel_right__6qSYX","top":"sidepanel_top__HjdT+","bottom":"sidepanel_bottom__Tg9-V"};
export const b = b_.with('sidePanel');